import { ScriptsUtility } from "./scripts.utility";
import { AgentUtility } from "./agent.utility";
import { environment } from "environments/environment";
import { Testability } from "../../../node_modules/@angular/core";
declare let Keycloak:any;

export class SSOUtility{
    private static keycloakAdapter:any;

    public static InitKeycloak():Promise<any>{
        return new Promise((resolve, reject) => {
            try{
                ScriptsUtility.load(["keycloak.js"])
                .then(() => {
                    SSOUtility.keycloakAdapter =  Keycloak(environment.keycloakCongig)
                    SSOUtility.keycloakAdapter.init({ onLoad: 'login-required', promiseType: 'native' })
                    .then((data) => {
                        if(SSOUtility.keycloakAdapter.tokenParsed.realm_access && SSOUtility.keycloakAdapter.tokenParsed.realm_access.roles.indexOf("agent") > -1){
                            if(SSOUtility.keycloakAdapter.tokenParsed.realm_access.roles.indexOf("agent") > -1)
                                AgentUtility.setToken(SSOUtility.keycloakAdapter.token);
                            else
                                AgentUtility.setToken(AgentUtility.ACCESS_DENIED);
                        }
                        else if(SSOUtility.keycloakAdapter.tokenParsed.resource_access && SSOUtility.keycloakAdapter.tokenParsed.resource_access["lka-backend"]){
                            if(SSOUtility.keycloakAdapter.tokenParsed.resource_access["lka-backend"].roles.indexOf("administrator") > -1)
                                AgentUtility.setToken(SSOUtility.keycloakAdapter.token);
                            else
                                AgentUtility.setToken(AgentUtility.ACCESS_DENIED);
                        }
                        else
                            AgentUtility.setToken(AgentUtility.ACCESS_DENIED)
                        resolve(data);
                    })
                    .catch(error => {throw error});
                })
                .catch(error => {throw error});
            }
            catch(error){
                reject(error);
            }
        })
    }

    public static get token():string{
        return SSOUtility.keycloakAdapter.token;
    }

    public static signOut(){
        SSOUtility.keycloakAdapter.logout();
    }

    public static async refreshToken(){
        if(SSOUtility.keycloakAdapter.isTokenExpired){
            await SSOUtility.keycloakAdapter.updateToken(30).then((res) => {
                if(res){
                    AgentUtility.setToken(SSOUtility.keycloakAdapter.token);
                    return;
                }
                else{
                    return;
                }
            });
            
        }
    }
    
}